<admin-header [primaryButtons]="headerPrimaryButtons" [title]="title" (eventFired)="headerButtonClick($event)"></admin-header>

<div class="container-fluid mt-3">

    <!-- CRM Enhanced: View As User -->
    <div class="row mb-3" *ngIf="isCrmEnhanced">
        <div class="col-12">
            <div class="d-flex align-items-center gap-2 p-2 rounded" style="background:#e7f0ff; border:1px solid #b6d4fe">
                <i class="fal fa-eye text-primary"></i>
                <span class="fw-semibold small text-primary">View as:</span>
                <dx-select-box [items]="userProfiles" displayExpr="fullName" valueExpr="id" [(value)]="viewAsUserProfileId" (onValueChanged)="onViewAsChanged()" [searchEnabled]="true" [showClearButton]="true" placeholder="Everyone (all tasks)" [width]="280" style="display:inline-block"></dx-select-box>
            </div>
        </div>
    </div>

    <!-- Quick Actions -->
    <div class="row mb-4">
        <div class="col mb-3">
            <div class="card h-100 border-0 shadow-sm crm-action-card crm-action-lead" style="cursor:pointer" (click)="openLeadModal()">
                <div class="card-body d-flex align-items-center">
                    <div class="crm-action-icon me-3"><i class="fal fa-user-plus fa-2x"></i></div>
                    <div>
                        <div class="fw-bold">New Lead</div>
                        <small class="text-muted">Capture a new prospect</small>
                    </div>
                </div>
            </div>
        </div>
        <div class="col mb-3">
            <div class="card h-100 border-0 shadow-sm crm-action-card crm-action-contact" style="cursor:pointer" (click)="openContactModal()">
                <div class="card-body d-flex align-items-center">
                    <div class="crm-action-icon me-3"><i class="fal fa-address-card fa-2x"></i></div>
                    <div>
                        <div class="fw-bold">New Contact</div>
                        <small class="text-muted">Add a person to the CRM</small>
                    </div>
                </div>
            </div>
        </div>
        <div class="col mb-3">
            <div class="card h-100 border-0 shadow-sm crm-action-card crm-action-event" style="cursor:pointer" (click)="openEventModal()">
                <div class="card-body d-flex align-items-center">
                    <div class="crm-action-icon me-3"><i class="fal fa-calendar-star fa-2x"></i></div>
                    <div>
                        <div class="fw-bold">New Event</div>
                        <small class="text-muted">Log a trade show or visit</small>
                    </div>
                </div>
            </div>
        </div>
        <div class="col mb-3">
            <div class="card h-100 border-0 shadow-sm crm-action-card crm-action-interaction" style="cursor:pointer" (click)="openInteractionModal()">
                <div class="card-body d-flex align-items-center">
                    <div class="crm-action-icon me-3"><i class="fal fa-comments fa-2x"></i></div>
                    <div>
                        <div class="fw-bold">Log Interaction</div>
                        <small class="text-muted">Record a call, email or meeting</small>
                    </div>
                </div>
            </div>
        </div>
        <div class="col mb-3">
            <div class="card h-100 border-0 shadow-sm crm-action-card crm-action-pipeline" style="cursor:pointer" (click)="openPipeline()">
                <div class="card-body d-flex align-items-center">
                    <div class="crm-action-icon me-3"><i class="fal fa-columns fa-2x"></i></div>
                    <div>
                        <div class="fw-bold">Pipeline</div>
                        <small class="text-muted">View opportunity board</small>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Pipeline Stats -->
    <div class="row mb-4">
        <div class="col-md-3">
            <div class="card text-center border-0 shadow-sm h-100" style="cursor:pointer" (click)="goToLeads()">
                <div class="card-body">
                    <div class="text-primary mb-1"><i class="fal fa-inbox fa-lg"></i></div>
                    <h2 class="mb-0 fw-bold">{{ newLeads }}</h2>
                    <small class="text-muted">New Leads</small>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card text-center border-0 shadow-sm h-100" style="cursor:pointer" (click)="goToLeads()">
                <div class="card-body">
                    <div class="text-warning mb-1"><i class="fal fa-phone fa-lg"></i></div>
                    <h2 class="mb-0 fw-bold">{{ contactedLeads }}</h2>
                    <small class="text-muted">Contacted Leads</small>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card text-center border-0 shadow-sm h-100" style="cursor:pointer" (click)="goToLeads()">
                <div class="card-body">
                    <div class="text-info mb-1"><i class="fal fa-check-circle fa-lg"></i></div>
                    <h2 class="mb-0 fw-bold">{{ qualifiedLeads }}</h2>
                    <small class="text-muted">Qualified Leads</small>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card text-center border-0 shadow-sm h-100" style="cursor:pointer" (click)="openPipeline()">
                <div class="card-body">
                    <div class="text-success mb-1"><i class="fal fa-trophy fa-lg"></i></div>
                    <h2 class="mb-0 fw-bold">{{ wonOpportunities }}</h2>
                    <small class="text-muted">Won Opportunities</small>
                </div>
            </div>
        </div>
    </div>

    <!-- My Tasks -->
    <div class="row mb-4" *ngIf="myTasks.length > 0">
        <div class="col-12">
            <div class="card border-0 shadow-sm">
                <div class="card-header bg-white border-bottom d-flex justify-content-between align-items-center">
                    <strong><i class="fal fa-tasks me-2 text-primary"></i>{{ viewAsUserProfileId ? 'Tasks' : (isCrmEnhanced ? 'All Tasks' : 'My Tasks') }}</strong>
                    <span class="badge bg-primary">{{ myTasks.length }}</span>
                </div>
                <div class="card-body p-0">
                    <table class="table table-sm table-hover mb-0">
                        <thead class="table-light"><tr><th>Title</th><th>Customer</th><th class="text-end">Sales Value</th><th>Created By</th><th>Due</th><th>Opportunity</th><th></th></tr></thead>
                        <tbody>
                            <ng-container *ngFor="let task of myTasks">
                                <tr style="cursor:pointer" (click)="expandedTaskId = expandedTaskId === task.id ? null : task.id">
                                    <td>
                                        <div class="d-flex align-items-center gap-1">
                                            <i class="fal fa-chevron-right small" [style.transform]="expandedTaskId === task.id ? 'rotate(90deg)' : ''" style="transition:transform 0.15s; opacity:0.4; width:12px" *ngIf="task.description"></i>
                                            <span>{{ task.title }}</span>
                                        </div>
                                    </td>
                                    <td>{{ getTaskCustomerName(task) || '—' }}</td>
                                    <td class="text-end">
                                        <span *ngIf="getTaskSalesValue(task) !== null">{{ getTaskSalesValue(task) | currency:'GBP':'symbol':'1.0-0' }}</span>
                                        <span *ngIf="getTaskSalesValue(task) === null" class="text-muted">—</span>
                                    </td>
                                    <td>{{ getTaskCreatedByName(task) || '—' }}</td>
                                    <td class="text-nowrap">
                                        <span class="badge" [class.bg-danger]="getTaskDueDateLabel(task.dueDate).includes('overdue') || getTaskDueDateLabel(task.dueDate) === 'Today'" [class.bg-warning]="getTaskDueDateLabel(task.dueDate) === 'Tomorrow'" [class.text-dark]="getTaskDueDateLabel(task.dueDate) === 'Tomorrow'" [class.bg-secondary]="!getTaskDueDateLabel(task.dueDate).includes('overdue') && getTaskDueDateLabel(task.dueDate) !== 'Today' && getTaskDueDateLabel(task.dueDate) !== 'Tomorrow'">{{ getTaskDueDateLabel(task.dueDate) }}</span>
                                        <span class="ms-1 text-muted small" *ngIf="task.dueDate">{{ task.dueDate | date:'dd/MM' }}</span>
                                    </td>
                                    <td>
                                        <a *ngIf="task.crmOpportunityId" style="cursor:pointer; text-decoration:underline" (click)="goToTask(task); $event.stopPropagation()">View</a>
                                        <span *ngIf="!task.crmOpportunityId" class="text-muted">—</span>
                                    </td>
                                    <td class="text-end">
                                        <button class="btn btn-sm btn-outline-success" (click)="toggleDashboardTaskComplete(task); $event.stopPropagation()" title="Mark complete"><i class="fal fa-check"></i></button>
                                    </td>
                                </tr>
                                <tr *ngIf="expandedTaskId === task.id && task.description">
                                    <td colspan="7" class="ps-4 pt-0 pb-2" style="border-top:none">
                                        <div class="text-muted small" style="white-space:pre-wrap">{{ task.description }}</div>
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

    <!-- Follow-ups -->
    <div class="row mb-4" *ngIf="followUps.length > 0">
        <div class="col-12">
            <div class="card border-0 shadow-sm">
                <div class="card-header bg-white border-bottom d-flex justify-content-between align-items-center">
                    <strong><i class="fal fa-bell me-2 text-warning"></i>Follow-ups Due (Next 2 Weeks)</strong>
                    <span class="badge bg-warning text-dark">{{ followUps.length }}</span>
                </div>
                <div class="card-body p-0">
                    <table class="table table-sm table-hover mb-0">
                        <thead class="table-light"><tr><th>Due</th><th>Client / Lead</th><th>Type</th><th>Summary</th><th></th></tr></thead>
                        <tbody>
                            <tr *ngFor="let followUp of followUps">
                                <td class="text-nowrap">
                                    <span class="badge" [class.bg-danger]="getFollowUpDaysLabel(followUp.followUpDate) === 'Today' || getFollowUpDaysLabel(followUp.followUpDate) === 'Tomorrow'" [class.bg-warning]="getFollowUpDaysLabel(followUp.followUpDate) !== 'Today' && getFollowUpDaysLabel(followUp.followUpDate) !== 'Tomorrow'" [class.text-dark]="getFollowUpDaysLabel(followUp.followUpDate) !== 'Today' && getFollowUpDaysLabel(followUp.followUpDate) !== 'Tomorrow'">{{ getFollowUpDaysLabel(followUp.followUpDate) }}</span>
                                    <span class="ms-1 text-muted small">{{ followUp.followUpDate | date:'dd/MM' }}</span>
                                </td>
                                <td>{{ getInteractionLink(followUp) }}</td>
                                <td>{{ getInteractionTypeName(followUp) }}</td>
                                <td class="text-truncate" style="max-width:200px">{{ followUp.summary }}</td>
                                <td class="text-end">
                                    <button class="btn btn-sm btn-outline-success me-1" (click)="markFollowUpDone(followUp)" title="Mark done"><i class="fal fa-check"></i></button>
                                    <button class="btn btn-sm btn-outline-secondary" (click)="goToInteraction(followUp.id)" title="Open record"><i class="fal fa-arrow-right"></i></button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

    <!-- Activity -->
    <div class="row">
        <div class="col-md-6">
            <div class="card mb-4 border-0 shadow-sm">
                <div class="card-header bg-white border-bottom d-flex justify-content-between align-items-center">
                    <strong><i class="fal fa-calendar-star me-2 text-info"></i>Upcoming Events</strong>
                    <button class="btn btn-sm btn-outline-primary" (click)="goToEvents()">View All</button>
                </div>
                <div class="card-body p-0">
                    <table class="table table-sm table-hover mb-0" *ngIf="upcomingEvents.length > 0">
                        <thead class="table-light"><tr><th>Event</th><th>Date</th><th>Location</th><th>Attending?</th></tr></thead>
                        <tbody>
                            <tr *ngFor="let event of upcomingEvents" style="cursor:pointer" (click)="openViewEvent(event)">
                                <td>{{ event.name }}</td>
                                <td class="text-nowrap">{{ event.startDate | date:'dd/MM/yyyy' }}</td>
                                <td>{{ event.location }}</td>
                                <td class="text-nowrap">
                                    <span *ngIf="event.attendingStatus === 0" class="badge bg-success">Yes</span>
                                    <span *ngIf="event.attendingStatus === 10" class="badge bg-danger">No</span>
                                    <span *ngIf="event.attendingStatus === 20" class="badge bg-warning text-dark">Maybe</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p class="text-muted p-3 mb-0" *ngIf="upcomingEvents.length === 0"><i class="fal fa-calendar me-2"></i>No upcoming events.</p>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="card mb-4 border-0 shadow-sm">
                <div class="card-header bg-white border-bottom d-flex justify-content-between align-items-center">
                    <strong><i class="fal fa-comments me-2 text-success"></i>Recent Interactions</strong>
                    <button class="btn btn-sm btn-outline-primary" (click)="goToInteractions()">View All</button>
                </div>
                <div class="card-body p-0">
                    <table class="table table-sm table-hover mb-0" *ngIf="recentInteractions.length > 0">
                        <thead class="table-light"><tr><th>Date / Time</th><th>Client / Lead</th><th>Type</th><th>Rating</th></tr></thead>
                        <tbody>
                            <tr *ngFor="let interaction of recentInteractions" style="cursor:pointer" (click)="openViewInteraction(interaction)">
                                <td class="text-nowrap">{{ interaction.interactionDate | date:'dd/MM/yyyy HH:mm' }}</td>
                                <td>{{ getInteractionLink(interaction) }}</td>
                                <td>{{ getInteractionTypeName(interaction) }}</td>
                                <td>{{ getRatingEmoji(interaction.rating) }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <p class="text-muted p-3 mb-0" *ngIf="recentInteractions.length === 0"><i class="fal fa-comments me-2"></i>No recent interactions.</p>
                </div>
            </div>
        </div>
    </div>

</div>

<div *ngIf="popupVisible" class="crm-modal-backdrop" (click)="closePopup()">
    <div class="crm-modal" (click)="$event.stopPropagation()">
        <div class="crm-modal-header">
            <span class="crm-modal-title">{{ pendingDismissFollowUp ? 'Log Follow-up Interaction' : 'New ' + popupType }}</span>
            <button class="crm-modal-close" (click)="closePopup()">✕</button>
        </div>
        <div class="crm-modal-body">

            <ng-container *ngIf="popupType === 'Task'">
                <dx-form [(formData)]="popupTask" labelLocation="top" [colCount]="2">
                    <dxi-item dataField="title" [colSpan]="2"><dxo-label text="Title"></dxo-label><dxi-validation-rule type="required"></dxi-validation-rule></dxi-item>
                    <dxi-item dataField="description" editorType="dxTextArea" [colSpan]="2" [editorOptions]="{ height: 80 }"><dxo-label text="Description"></dxo-label></dxi-item>
                    <dxi-item dataField="dueDate" editorType="dxDateBox" [editorOptions]="{ displayFormat: 'dd/MM/yyyy', type: 'date', showClearButton: true }"><dxo-label text="Due Date"></dxo-label></dxi-item>
                    <dxi-item dataField="assignedToUserProfileId" editorType="dxSelectBox" [editorOptions]="{ items: userProfiles, displayExpr: 'fullName', valueExpr: 'id', searchEnabled: true, showClearButton: true, placeholder: 'Assign to...' }"><dxo-label text="Assigned To"></dxo-label></dxi-item>
                    <dxi-item dataField="crmOpportunityId" editorType="dxSelectBox" [colSpan]="2" [editorOptions]="{ items: opportunities, displayExpr: 'name', valueExpr: 'id', searchEnabled: true, showClearButton: true, placeholder: 'No opportunity (standalone task)' }"><dxo-label text="Opportunity (optional)"></dxo-label></dxi-item>
                </dx-form>
            </ng-container>

            <ng-container *ngIf="popupType === 'Lead'">
                <dx-form [(formData)]="popupLead" labelLocation="top" [colCount]="2">
                    <dxi-item dataField="companyName" [colSpan]="2"><dxo-label text="Company Name"></dxo-label></dxi-item>
                    <dxi-item dataField="firstName"><dxo-label text="First Name"></dxo-label></dxi-item>
                    <dxi-item dataField="lastName"><dxo-label text="Last Name"></dxo-label></dxi-item>
                    <dxi-item dataField="email"><dxo-label text="Email"></dxo-label></dxi-item>
                    <dxi-item dataField="phone"><dxo-label text="Phone"></dxo-label></dxi-item>
                    <dxi-item dataField="status" editorType="dxSelectBox" [editorOptions]="{ items: leadStatuses, displayExpr: 'name', valueExpr: 'id' }"><dxo-label text="Status"></dxo-label></dxi-item>
                    <dxi-item dataField="source" editorType="dxSelectBox" [editorOptions]="{ items: leadSources, displayExpr: 'name', valueExpr: 'id' }"><dxo-label text="Source"></dxo-label></dxi-item>
                    <dxi-item dataField="sector" editorType="dxSelectBox" [colSpan]="2" [editorOptions]="{ items: businessSectors, displayExpr: 'name', valueExpr: 'id', showClearButton: true, placeholder: 'Select sector...' }"><dxo-label text="Sector"></dxo-label></dxi-item>
                    <dxi-item dataField="assignedUserId" editorType="dxSelectBox" [colSpan]="2" [editorOptions]="{ items: userProfiles, displayExpr: 'fullName', valueExpr: 'id', searchEnabled: true, placeholder: 'Assign to...' }"><dxo-label text="Assigned To"></dxo-label></dxi-item>
                    <dxi-item dataField="notes" editorType="dxTextArea" [colSpan]="2" [editorOptions]="{ height: 80 }"><dxo-label text="Notes"></dxo-label></dxi-item>
                    <dxi-item dataField="isSensitive" editorType="dxCheckBox" [colSpan]="2"><dxo-label text="Sensitive"></dxo-label></dxi-item>
                </dx-form>
            </ng-container>

            <ng-container *ngIf="popupType === 'Contact'">
                <dx-form [(formData)]="popupContact" labelLocation="top" [colCount]="2">
                    <dxi-item dataField="firstName"><dxo-label text="First Name"></dxo-label></dxi-item>
                    <dxi-item dataField="lastName"><dxo-label text="Last Name"></dxo-label></dxi-item>
                    <dxi-item dataField="email"><dxo-label text="Email"></dxo-label></dxi-item>
                    <dxi-item dataField="phone"><dxo-label text="Phone"></dxo-label></dxi-item>
                    <dxi-item dataField="jobTitle" [colSpan]="2"><dxo-label text="Job Title"></dxo-label></dxi-item>
                    <dxi-item dataField="crmLeadId" editorType="dxSelectBox" [colSpan]="2" [editorOptions]="{ items: leads, displayExpr: 'companyName', valueExpr: 'id', searchEnabled: true, showClearButton: true, placeholder: 'Link to lead...' }"><dxo-label text="Lead"></dxo-label></dxi-item>
                    <dxi-item dataField="notes" editorType="dxTextArea" [colSpan]="2" [editorOptions]="{ height: 80 }"><dxo-label text="Notes"></dxo-label></dxi-item>
                    <dxi-item dataField="isSensitive" editorType="dxCheckBox" [colSpan]="2"><dxo-label text="Sensitive"></dxo-label></dxi-item>
                    <dxi-item dataField="christmasGift" editorType="dxCheckBox" [colSpan]="2"><dxo-label text="Send Christmas Gift"></dxo-label></dxi-item>
                    <dxi-item dataField="christmasGiftNotes" editorType="dxTextArea" [colSpan]="2" [editorOptions]="{ height: 60 }"><dxo-label text="Gift Notes"></dxo-label></dxi-item>
                </dx-form>
            </ng-container>

            <ng-container *ngIf="popupType === 'Event'">
                <dx-form [(formData)]="popupEvent" labelLocation="top" [colCount]="2">
                    <dxi-item dataField="name" [colSpan]="2"><dxo-label text="Event Name"></dxo-label></dxi-item>
                    <dxi-item dataField="organiser" [colSpan]="2"><dxo-label text="Organiser"></dxo-label></dxi-item>
                    <dxi-item dataField="eventType" editorType="dxSelectBox" [editorOptions]="{ items: eventTypes, displayExpr: 'name', valueExpr: 'id' }"><dxo-label text="Type"></dxo-label></dxi-item>
                    <dxi-item dataField="attendingStatus" editorType="dxSelectBox" [editorOptions]="{ items: attendingStatuses, displayExpr: 'name', valueExpr: 'id' }"><dxo-label text="Are We Attending?"></dxo-label></dxi-item>
                    <dxi-item dataField="startDate" editorType="dxDateBox" [editorOptions]="{ displayFormat: 'dd/MM/yyyy', type: 'date' }"><dxo-label text="Start Date"></dxo-label></dxi-item>
                    <dxi-item dataField="endDate" editorType="dxDateBox" [editorOptions]="{ displayFormat: 'dd/MM/yyyy', type: 'date' }"><dxo-label text="End Date"></dxo-label></dxi-item>
                    <dxi-item dataField="location" [colSpan]="2"><dxo-label text="Location"></dxo-label></dxi-item>
                    <dxi-item dataField="notes" editorType="dxTextArea" [colSpan]="2" [editorOptions]="{ height: 80 }"><dxo-label text="Notes"></dxo-label></dxi-item>
                    <dxi-item dataField="isSensitive" editorType="dxCheckBox" [colSpan]="2"><dxo-label text="Sensitive"></dxo-label></dxi-item>
                </dx-form>
            </ng-container>

            <ng-container *ngIf="popupType === 'Interaction'">
                <dx-form [(formData)]="popupInteraction" labelLocation="top" [colCount]="2">
                    <dxi-item dataField="interactionType" editorType="dxSelectBox" [editorOptions]="{ items: interactionTypes, displayExpr: 'name', valueExpr: 'id' }"><dxo-label text="Type"></dxo-label></dxi-item>
                    <dxi-item dataField="interactionDate" editorType="dxDateBox" [editorOptions]="{ displayFormat: 'dd/MM/yyyy HH:mm', type: 'datetime' }"><dxo-label text="Date & Time"></dxo-label></dxi-item>
                    <dxi-item dataField="summary" editorType="dxTextArea" [colSpan]="2" [editorOptions]="{ height: 70 }"><dxo-label text="Summary"></dxo-label></dxi-item>
                    <dxi-item itemType="simple" [colSpan]="2">
                        <div *dxTemplate>
                            <div class="quick-summaries">
                                <button *ngFor="let qs of quickSummaries" type="button" class="quick-summary-btn" (click)="addQuickSummary(qs)">{{ qs }}</button>
                            </div>
                        </div>
                    </dxi-item>
                    <dxi-item dataField="outcome" editorType="dxTextArea" [colSpan]="2" [editorOptions]="{ height: 70 }"><dxo-label text="Outcome"></dxo-label></dxi-item>
                    <dxi-item itemType="simple" [colSpan]="2">
                        <div *dxTemplate>
                            <div class="quick-summaries">
                                <button *ngFor="let qo of quickOutcomes" type="button" class="quick-summary-btn quick-outcome-btn" (click)="addQuickOutcome(qo)">{{ qo }}</button>
                            </div>
                        </div>
                    </dxi-item>
                </dx-form>

                <div class="mt-3">
                    <div class="text-muted small fw-semibold mb-2">ORIGINATOR</div>
                    <div class="btn-group mb-1">
                        <button type="button" class="btn btn-sm" [class.btn-primary]="popupInteraction.originator !== 1" [class.btn-outline-primary]="popupInteraction.originator === 1" (click)="popupInteraction.originator = 0">Us</button>
                        <button type="button" class="btn btn-sm" [class.btn-primary]="popupInteraction.originator === 1" [class.btn-outline-primary]="popupInteraction.originator !== 1" (click)="popupInteraction.originator = 1">Them</button>
                    </div>
                </div>

                <div class="mt-3">
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="popupSensitive" [(ngModel)]="popupInteraction.isSensitive">
                        <label class="form-check-label text-muted small" for="popupSensitive">Sensitive</label>
                    </div>
                </div>

                <div class="mt-3">
                    <div class="text-muted small fw-semibold mb-2">FOLLOW UP IN</div>
                    <div class="crm-rating-picker flex-wrap">
                        <button type="button" class="crm-rating-btn crm-followup-btn" [class.active]="popupInteractionFollowUp === '1d'" (click)="setFollowUpDays(1)">1d</button>
                        <button type="button" class="crm-rating-btn crm-followup-btn" [class.active]="popupInteractionFollowUp === '2d'" (click)="setFollowUpDays(2)">2d</button>
                        <button type="button" class="crm-rating-btn crm-followup-btn" [class.active]="popupInteractionFollowUp === '3d'" (click)="setFollowUpDays(3)">3d</button>
                        <button type="button" class="crm-rating-btn crm-followup-btn" [class.active]="popupInteractionFollowUp === '4d'" (click)="setFollowUpDays(4)">4d</button>
                        <button type="button" class="crm-rating-btn crm-followup-btn crm-followup-separator" [class.active]="popupInteractionFollowUp === '1w'" (click)="setFollowUpWeeks(1)">1w</button>
                        <button type="button" class="crm-rating-btn crm-followup-btn" [class.active]="popupInteractionFollowUp === '2w'" (click)="setFollowUpWeeks(2)">2w</button>
                        <button type="button" class="crm-rating-btn crm-followup-btn" [class.active]="popupInteractionFollowUp === '3w'" (click)="setFollowUpWeeks(3)">3w</button>
                        <button type="button" class="crm-rating-btn crm-followup-btn" [class.active]="popupInteractionFollowUp === '4w'" (click)="setFollowUpWeeks(4)">4w</button>
                        <button type="button" class="crm-rating-btn crm-followup-btn" [class.active]="popupInteractionFollowUp === '6w'" (click)="setFollowUpWeeks(6)">6w</button>
                        <button type="button" class="crm-rating-btn crm-followup-btn" [class.active]="popupInteractionFollowUp === '8w'" (click)="setFollowUpWeeks(8)">8w</button>
                    </div>
                    <small class="text-muted" *ngIf="popupInteraction.followUpDate">Follow up on {{ popupInteraction.followUpDate | date:'dd/MM/yyyy' }}</small>
                </div>

                <div class="mt-3">
                    <div class="text-muted small fw-semibold mb-2">RATING</div>
                    <div class="crm-rating-picker">
                        <button type="button" class="crm-rating-btn" [class.active]="popupInteraction.rating === 0" (click)="popupInteraction.rating = popupInteraction.rating === 0 ? undefined : 0" title="Positive">😊</button>
                        <button type="button" class="crm-rating-btn" [class.active]="popupInteraction.rating === 1" (click)="popupInteraction.rating = popupInteraction.rating === 1 ? undefined : 1" title="Neutral">😐</button>
                        <button type="button" class="crm-rating-btn" [class.active]="popupInteraction.rating === 2" (click)="popupInteraction.rating = popupInteraction.rating === 2 ? undefined : 2" title="Negative">😞</button>
                    </div>
                </div>

                <hr class="my-3">

                <div class="row g-2">
                    <div class="col-12">
                        <label class="form-label">Lead <span class="text-danger">*</span></label>
                        <dx-select-box [items]="leads" displayExpr="companyName" valueExpr="id" [(value)]="popupInteraction.crmLeadId" (onValueChanged)="updateFilteredPopupContacts()" [searchEnabled]="true" [showClearButton]="true" placeholder="Select lead..."></dx-select-box>
                    </div>
                    <div class="col-12">
                        <label class="form-label">Contact <span class="text-danger">*</span></label>
                        <dx-select-box [items]="filteredPopupContacts" displayExpr="fullName" valueExpr="id" [(value)]="popupInteraction.crmContactId" [searchEnabled]="true" [showClearButton]="true" placeholder="Select contact..."></dx-select-box>
                    </div>
                    <div class="col-12">
                        <label class="form-label">Event <span class="text-muted fw-normal">(optional)</span></label>
                        <dx-select-box [items]="events" displayExpr="name" valueExpr="id" [(value)]="popupInteraction.crmEventId" [searchEnabled]="true" [showClearButton]="true" placeholder="Select event..."></dx-select-box>
                    </div>
                </div>
            </ng-container>

        </div>
        <div class="crm-modal-footer">
            <button class="btn btn-outline-secondary" (click)="closePopup()">Cancel</button>
            <button class="btn btn-primary" (click)="popupSave()">{{ popupSaveLabel }}</button>
        </div>
    </div>
</div>

<div *ngIf="viewInteractionVisible" class="crm-modal-backdrop">
    <div class="crm-modal">
        <div class="crm-modal-header">
            <span class="crm-modal-title">{{ getInteractionTypeName(viewInteraction) }} — {{ viewInteraction.interactionDate | date:'dd/MM/yyyy HH:mm' }}</span>
            <button class="crm-modal-close" (click)="viewInteractionVisible = false">✕</button>
        </div>
        <div class="crm-modal-body">
            <div class="row g-3">
                <div class="col-6">
                    <div class="text-muted small fw-semibold mb-1">CLIENT / LEAD</div>
                    <div>{{ getInteractionLink(viewInteraction) }}</div>
                </div>
                <div class="col-4">
                    <div class="text-muted small fw-semibold mb-1">TYPE</div>
                    <div>{{ getInteractionTypeName(viewInteraction) }}</div>
                </div>
                <div class="col-2">
                    <div class="text-muted small fw-semibold mb-1">RATING</div>
                    <div style="font-size:1.4rem">{{ getRatingEmoji(viewInteraction.rating) }}</div>
                </div>
                <div class="col-12" *ngIf="viewInteraction.summary">
                    <div class="text-muted small fw-semibold mb-1">SUMMARY</div>
                    <div style="white-space: pre-wrap">{{ viewInteraction.summary }}</div>
                </div>
                <div class="col-12" *ngIf="viewInteraction.outcome">
                    <div class="text-muted small fw-semibold mb-1">OUTCOME</div>
                    <div style="white-space: pre-wrap">{{ viewInteraction.outcome }}</div>
                </div>
            </div>
        </div>
        <div class="crm-modal-footer">
            <button class="btn btn-outline-secondary" (click)="viewInteractionVisible = false">Close</button>
            <button class="btn btn-outline-primary" (click)="goToInteraction(viewInteraction.id)">Open Full Record</button>
        </div>
    </div>
</div>

<div *ngIf="viewEventVisible" class="crm-modal-backdrop" (click)="viewEventVisible = false">
    <div class="crm-modal" (click)="$event.stopPropagation()">
        <div class="crm-modal-header">
            <span class="crm-modal-title">{{ viewEvent.name }}</span>
            <button class="crm-modal-close" (click)="viewEventVisible = false">✕</button>
        </div>
        <div class="crm-modal-body">
            <div class="row g-3">
                <div class="col-6" *ngIf="viewEvent.organiser">
                    <div class="text-muted small fw-semibold mb-1">ORGANISER</div>
                    <div>{{ viewEvent.organiser }}</div>
                </div>
                <div class="col-6">
                    <div class="text-muted small fw-semibold mb-1">ATTENDING?</div>
                    <div>
                        <span *ngIf="viewEvent.attendingStatus === 0" class="badge bg-success">Yes</span>
                        <span *ngIf="viewEvent.attendingStatus === 10" class="badge bg-danger">No</span>
                        <span *ngIf="viewEvent.attendingStatus === 20" class="badge bg-warning text-dark">Maybe</span>
                    </div>
                </div>
                <div class="col-6">
                    <div class="text-muted small fw-semibold mb-1">START DATE</div>
                    <div>{{ viewEvent.startDate | date:'dd/MM/yyyy' }}</div>
                </div>
                <div class="col-6" *ngIf="viewEvent.endDate">
                    <div class="text-muted small fw-semibold mb-1">END DATE</div>
                    <div>{{ viewEvent.endDate | date:'dd/MM/yyyy' }}</div>
                </div>
                <div class="col-12" *ngIf="viewEvent.location">
                    <div class="text-muted small fw-semibold mb-1">LOCATION</div>
                    <div>{{ viewEvent.location }}</div>
                </div>
                <div class="col-12" *ngIf="viewEvent.notes">
                    <div class="text-muted small fw-semibold mb-1">NOTES</div>
                    <div style="white-space: pre-wrap">{{ viewEvent.notes }}</div>
                </div>
                <div class="col-12">
                    <div class="text-muted small fw-semibold mb-2">ATTENDEES</div>
                    <table class="table table-sm mb-0" *ngIf="viewEventAttendees.length > 0">
                        <tbody>
                            <tr *ngFor="let attendee of viewEventAttendees">
                                <td>{{ getAttendeeName(attendee.userProfileId) }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <p class="text-muted small mb-0" *ngIf="viewEventAttendees.length === 0">No attendees recorded.</p>
                </div>
            </div>
        </div>
        <div class="crm-modal-footer">
            <button class="btn btn-outline-secondary" (click)="viewEventVisible = false">Close</button>
            <button class="btn btn-outline-primary" (click)="goToEvent(viewEvent.id)">Open Full Record</button>
        </div>
    </div>
</div>

<!-- Floating Action Button -->
<div class="crm-fab-container">
    <div class="crm-fab-options" [class.open]="fabOpen">
        <button class="crm-fab-option" (click)="openLeadModal(); fabOpen = false" title="New Lead"><i class="fal fa-user-plus"></i><span>Lead</span></button>
        <button class="crm-fab-option" (click)="openContactModal(); fabOpen = false" title="New Contact"><i class="fal fa-address-card"></i><span>Contact</span></button>
        <button class="crm-fab-option" (click)="openEventModal(); fabOpen = false" title="New Event"><i class="fal fa-calendar-star"></i><span>Event</span></button>
        <button class="crm-fab-option" (click)="fabNewOpportunity(); fabOpen = false" title="New Opportunity"><i class="fal fa-handshake"></i><span>Opportunity</span></button>
        <button class="crm-fab-option" (click)="fabNewTask(); fabOpen = false" title="New Task"><i class="fal fa-tasks"></i><span>Task</span></button>
    </div>
    <button class="crm-fab-btn" (click)="fabOpen = !fabOpen" [class.active]="fabOpen"><i class="fal" [class.fa-plus]="!fabOpen" [class.fa-times]="fabOpen"></i></button>
</div>
